module.exports = __webpack_public_path__ + "imgs/sms.a3322e9faa2110d7f96a8d1e87ee6cb3.svg";